import axios from 'axios';

// Auto-detect environment and use appropriate API URL
const getApiUrl = () => {
  // If environment variable is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Otherwise, detect based on hostname (local dev only)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5001/api';
  }

  // Production fallback
  console.error('⚠️ REACT_APP_API_URL not set! Defaulting to localhost.');
  return 'http://localhost:5001/api';
};

const API_URL = getApiUrl();

// Log API URL once on module load
console.log('🔗 API Base URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
});

// Temporary: Remove Clerk authentication
api.interceptors.request.use(
  async (config) => {
    // No authentication for now
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const userAPI = {
  createOrUpdateProfile: (data) => api.post('/users/profile', data),
  getProfile: () => api.get('/users/profile'),
};

export const cartAPI = {
  getCart: () => api.get('/cart'),
  addToCart: (productId, category, quantity) => api.post('/cart', { productId, category, quantity }),
  updateQuantity: (productId, quantity) => api.put(`/cart/${productId}`, { quantity }),
  removeFromCart: (productId) => api.delete(`/cart/${productId}`),
  clearCart: () => api.delete('/cart'),
  getRecommendations: () => api.get('/cart/recommendations'),
};

export const orderAPI = {
  createOrder: () => api.post('/orders'),
  getOrders: () => api.get('/orders'),
  getOrderById: (orderId) => api.get(`/orders/${orderId}`),
  reorder: (orderId) => api.post(`/orders/${orderId}/reorder`),
};

export const categoriesAPI = {
  getAllCategories: () => api.get('/categories'),
};

export const productsAPI = {
  getAllProducts: () => api.get('/products'),
  getProductsByCategory: (category) => api.get(`/products/category/${category}`),
  getProductsByVendor: (vendorSlug) => api.get(`/products/vendor/${vendorSlug}`),
  getProductById: (category, id) => api.get(`/products/category/${category}/${id}`),
  searchProducts: (query) => api.get(`/products/search?q=${query}`),
};

export const productGroupsAPI = {
  getProductGroups: (params) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/product-groups?${queryString}`);
  },
  getProductGroupById: (id) => api.get(`/product-groups/${id}`),
  getProductSuggestions: (id) => api.get(`/product-groups/suggestion/${id}`),
  getTrendingSuggestions: () => api.get(`/product-groups/trending`),
  getAvailableFilters: () => api.get('/product-groups/filters'),
  getProductGroupsMeta: () => api.get('/product-groups/meta'),
  
  // Admin methods
  getAllForAdmin: () => api.get('/product-groups/admin/all'),
  updateGroup: (id, data) => api.put(`/product-groups/admin/${id}`, data),
  mergeGroups: (sourceId, targetId) => api.post('/product-groups/admin/merge', { sourceId, targetId }),
  splitVariant: (variantId, newTitle) => api.post('/product-groups/admin/split', { variantId, newTitle }),
  updateVariant: (variantId, data) => api.put(`/product-groups/admin/variant/${variantId}`, data),
};


export const brandColorsAPI = {
  // Public
  getAll: () => api.get('/brand-colors'),
  getById: (id) => api.get(`/brand-colors/${id}`),

  // Batch get by color names
  getByNames: (color_names) =>
    api.post('/brand-colors/by-names', { color_names }),

  // Admin
  getAllForAdmin: () => api.get('/brand-colors/admin/all'),
  getByIdAdmin: (id) => api.get(`/brand-colors/admin/${id}`),
  create: (data) => api.post('/brand-colors/admin/create', data),
  update: (id, data) => api.put(`/brand-colors/admin/${id}`, data),
  remove: (id) => api.delete(`/brand-colors/admin/${id}`),
};

export const productComboAPI = {
  // Lấy thông tin cơ bản (basic) theo product_group_id
  getComboBasicByProductGroupId: (productGroupId) =>
    api.get(`/product-combos/${productGroupId}/basic`),
};

export const userEventAPI = {
  // Track user event
  track: (data) => api.post('/user-event', data),
};

// Export API_URL for components that need direct fetch
export { API_URL };

export default api;
